import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';

import { ApiCmsTranslations } from './api-cms-translations.models';


export interface ApiCmsTranslationsServiceInterface {
  translations(storeCode: string, languageCode: string): Observable<ApiCmsTranslations | undefined>;
}

@Injectable()
export class ApiCmsTranslationsService implements ApiCmsTranslationsServiceInterface {

  constructor(
    private readonly ecommerceConfigService: EcommerceConfigService,
    private readonly http: HttpClient
  ) {}

  public translations(countryCode: string, languageCode: string): Observable<ApiCmsTranslations | undefined> {
    const iTranstationsJSON = sessionStorage.getItem('iTranstationsJSON');
    if (iTranstationsJSON) {
      return of(JSON.parse(iTranstationsJSON));
    }

    const config = this.ecommerceConfigService.getConfig();
    const url = (config.providers.cmsTranslationsStaticBaseUrl
      ? `${config.providers.cmsTranslationsStaticBaseUrl}/${countryCode}-${languageCode}.json`
      : `${config.providers.cmsTranslationsBaseUrl}/${countryCode}/${languageCode}?device=webApp&tags=web_render`);

    if (config.providers.cmsTranslationsStaticBaseUrl !== undefined
      || config.providers.cmsTranslationsBaseUrl !== undefined) {
      return this.http.get<ApiCmsTranslations>(url).pipe(
        catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
      );
    }
    return of({});
  }

}
